<style scoped>
  .attachment{
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .selected {
    color: #1976d2
  }
</style>
<template>
  <div class="wrapper text-left">
    <v-chip
      v-for="file in files"
      :key="file.id"
      :class="`attachment ${canSelected&&selectedItem===file&&'selected'}`"
      :close="close"
      color="blue"
      small
      outlined
      @click="clickThisFile(file)"
      @click:close="confirmDeleteAttachment(file)"
    >
      {{ file.name }}
    </v-chip>
  </div>
</template>
<script>
  export default {
    props: {
      close: {
        type: Boolean,
        default: () => true
      },
      files: {
        type: Array,
        default() {
          return [];
        }
      },
      modelType: {
        type: String,
        required: true
      },
      modelId: {
        type: Number
      },
      canSelected: {
        type:Boolean,
        default: () => false
      },
      selectedItem: {
        type: Object
      }
    },
    methods: {
      clickThisFile(file) {
        this.$emit('clickFile', file)
      },
      confirmDeleteAttachment(file) {
        if (!this.modelId) {
          this.$util.removeArrayItem(this.files, file);
          return;
        }
        this.$Modal.confirm({
          title: '删除确认',
          content: `你确定要删除 ${file.name} 吗?`,
          onOk:() => {
            this.$util.ajax.post(this.$util.api.delete_model_file, {
              bfile_id: file.id,
              link_model_type: this.modelType,
              link_model_id: this.modelId
            }).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                this.$util.removeArrayItem(this.files, file);
                this.$Message.success('删除成功!');
                this.$emit('delSuccess')
              } else {
                this.$Modal.error({title: '提示', content: res.msg});
              }
            }).catch((e) => {
              this.$Modal.error({title: '提示', content: e.message});
            });
          }
        });
      },
    }
  }
</script>
